import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c6307de4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ApplyPopin__Content" }
const _hoisted_2 = { class: "ApplyPopin__EventRecap" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ApplyPopin__Logo" }, [
  /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 190 66" }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-logo" })
  ])
], -1))
const _hoisted_4 = { class: "ApplyPopin__Title" }
const _hoisted_5 = { class: "ApplyPopin__Text text-lg" }
const _hoisted_6 = { class: "ApplyPopin__EventContainer" }
const _hoisted_7 = { class: "ApplyPopin__Event" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "ApplyPopin__Event__Bg",
  viewBox: "0 0 482 204",
  "xml:space": "preserve"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M465,0H275.5c-3.9,0-7.4,1.4-10.5,3.5c-3.1,2-6,4.7-8.6,7.2c-4,3.9-9.4,6.3-15.4,6.3s-11.4-2.4-15.4-6.3\n                  c-2.6-2.5-5.4-5.2-8.6-7.2c-3.1-2-6.6-3.5-10.5-3.5H17C7.6,0,0,7.6,0,17v170c0,9.4,7.6,17,17,17h192.2c6.8,0,12.6-4.6,17.4-8.7\n                  c3.8-3.3,8.9-5.3,14.3-5.3s10.5,2,14.3,5.3c4.8,4.1,10.6,8.7,17.4,8.7H465c9.4,0,17-7.6,17-17V17C482,7.6,474.4,0,465,0z M480,187\n                  c0,8.3-6.7,15-15,15H272.8c-6,0-11.2-4-16.1-8.2c-4.2-3.6-9.7-5.8-15.6-5.8s-11.4,2.2-15.6,5.8c-4.9,4.2-10.1,8.2-16.1,8.2H17\n                  c-8.3,0-15-6.7-15-15V17C2,8.7,8.7,2,17,2h189.5c3.4,0,6.5,1.3,9.4,3.2c3,1.9,5.7,4.5,8.3,7c4.3,4.2,10.2,6.8,16.8,6.8\n                  s12.5-2.6,16.8-6.8c2.6-2.5,5.3-5.1,8.3-7c2.9-1.9,6.1-3.2,9.4-3.2H465c8.3,0,15,6.7,15,15V187z" })
], -1))
const _hoisted_9 = { class: "ApplyPopin__Event__Left" }
const _hoisted_10 = { class: "ApplyPopin__Event__Right" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = {
  class: "ApplyPopin__FormContainer",
  ref: "form"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EventsDate = _resolveComponent("EventsDate")!
  const _component_ButtonClose = _resolveComponent("ButtonClose")!
  const _component_FormCheckout = _resolveComponent("FormCheckout")!
  const _component_EventsRegisterEnd = _resolveComponent("EventsRegisterEnd")!
  const _component_FocusTrap = _resolveComponent("FocusTrap")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, {
      name: "popin",
      duration: 1200
    }, {
      default: _withCtx(() => [
        (_ctx.active)
          ? (_openBlock(), _createElementBlock("div", {
              ref: "popin",
              class: "ApplyPopin padded grid",
              key: 'job-apply-popin-' + _ctx.event.slug
            }, [
              _createVNode(_component_FocusTrap, { active: _ctx.active }, {
                default: _withCtx(() => [
                  _createVNode(_Transition, {
                    name: "fade",
                    duration: 1000
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["ApplyPopin__Layout grid", { 'ApplyPopin__Layout--disabled': _ctx.ended }])
                        }, [
                          _createElementVNode("div", _hoisted_2, [
                            _hoisted_3,
                            _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.event.name), 1),
                            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("events.confirmText")), 1),
                            _createElementVNode("div", _hoisted_6, [
                              _createElementVNode("div", _hoisted_7, [
                                _hoisted_8,
                                _createElementVNode("div", _hoisted_9, [
                                  _createVNode(_component_EventsDate, {
                                    date: _ctx.event.start_date,
                                    size: "large"
                                  }, null, 8, ["date"])
                                ]),
                                _createElementVNode("div", _hoisted_10, [
                                  _createElementVNode("h2", null, _toDisplayString(_ctx.$t("events.where")), 1),
                                  _createElementVNode("p", {
                                    innerHTML: `${_ctx.event.city}`
                                  }, null, 8, _hoisted_11),
                                  _createElementVNode("h2", null, _toDisplayString(_ctx.$t("events.ticketPrice")), 1),
                                  _createElementVNode("p", {
                                    class: "text-large",
                                    innerHTML: `$${_ctx.event.price}`
                                  }, null, 8, _hoisted_12)
                                ])
                              ])
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "ApplyPopin__GetTicket button button--white",
                              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.scrollToForm && _ctx.scrollToForm(...args)))
                            }, _toDisplayString(_ctx.$t("events.getTicket")), 1),
                            _createVNode(_component_ButtonClose, {
                              class: "ApplyPopin__Close ApplyPopin__Close--mobile",
                              onClick: _ctx.onClose,
                              variant: "light"
                            }, null, 8, ["onClick"])
                          ]),
                          _createElementVNode("div", _hoisted_13, [
                            _createVNode(_component_FormCheckout, {
                              onOnSubmit: _ctx.onCheckoutSubmit,
                              "is-loading": _ctx.isLoading,
                              errors: _ctx.errors,
                              initialPrice: _ctx.event.price,
                              title: _ctx.$t('events.formTitle'),
                              promocodeType: 'event',
                              event: _ctx.event.id
                            }, null, 8, ["onOnSubmit", "is-loading", "errors", "initialPrice", "title", "event"]),
                            _createVNode(_component_ButtonClose, {
                              class: "ApplyPopin__Close ApplyPopin__Close--mobile",
                              onClick: _ctx.onClose,
                              variant: "dark"
                            }, null, 8, ["onClick"])
                          ], 512),
                          _createVNode(_component_ButtonClose, {
                            "data-fixed": "",
                            class: "ApplyPopin__Close ApplyPopin__Close--desktop",
                            onClick: _ctx.onClose,
                            variant: "dark"
                          }, null, 8, ["onClick"])
                        ], 2),
                        (_ctx.ended)
                          ? (_openBlock(), _createBlock(_component_EventsRegisterEnd, {
                              key: 0,
                              class: "ApplyPopin__EventsRegisterEnd",
                              onClose: _cache[1] || (_cache[1] = () => {_ctx.onClose(); _ctx.$router.push('/dashboard');})
                            }))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["active"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}